import React from 'react';
import classNames from 'classnames';
import { SwitchTransition, Transition, TransitionStatus } from 'react-transition-group';
import { TooltipComponent } from 'src/common/tooltip/component';
import { CloseStrongIcon } from 'src/monet/icons';
import { SaveStatus } from 'src/store/step-editor';
import LoadingSpinner from 'src/common/components/loading-spinner';
import OfflineRegularIcon from 'src/monet/icons/OfflineRegularIcon';

type Props = {
  saveStatus: SaveStatus;
};

const getFadeClassNames = (state: TransitionStatus) => {
  return classNames('transition-opacity duration-200', {
    'opacity-100': state === 'entered',
    'opacity-0': state !== 'entered',
    none: state === 'exited',
    block: state !== 'exited',
  });
};

export const StepEditorSaveStatusIndicator = ({ saveStatus }: Props) => {
  return (
    <SwitchTransition mode='out-in'>
      <Transition key={saveStatus} timeout={200} unmountOnExit mountOnEnter>
        {(state) => {
          const fadeClassNames = getFadeClassNames(state);
          if (saveStatus === 'saving') {
            return <LoadingSpinner containerClassName={fadeClassNames} />;
          } else if (saveStatus === 'error') {
            return (
              <div className={fadeClassNames}>
                <TooltipComponent
                  tooltipContent="No connection detected - we'll keep trying to save your progress"
                  placement='bottom'
                  styling='tooltip'
                  theme='journey'
                >
                  <OfflineRegularIcon className='text-bedrock-red' />
                </TooltipComponent>
              </div>
            );
          } else {
            return <div className={fadeClassNames}></div>;
          }
        }}
      </Transition>
    </SwitchTransition>
  );
};
